import React, { useRef } from 'react';
import classNames from 'classnames';
import styles from './TwoFactorInput.module.scss';

export default function TwoFactorInput({ length = 6, inputName, helpLabel, onChange, onComplete }) {
  const inputsRef = useRef([]);

  const handleChange = (e, idx) => {
    const val = e.target.value.replace(/\D/g, '');
    e.target.value = val.slice(-1);

    const values = inputsRef.current.map(i => i.value).join('');
    onChange?.(e, values);

    if (val && idx < length - 1) {
      inputsRef.current[idx + 1].focus();
    }

    if (values.length === length) {
      onComplete?.(values);
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === 'Backspace' && !inputsRef.current[idx].value && idx > 0) {
      inputsRef.current[idx - 1].focus();
      inputsRef.current[idx - 1].setSelectionRange(1, 1); // move caret to end
    }

    if (e.key === 'ArrowLeft' && idx > 0) {
      e.preventDefault(); // prevent default cursor movement
      inputsRef.current[idx - 1].focus();
      inputsRef.current[idx - 1].setSelectionRange(1, 1);
    }

    if (e.key === 'ArrowRight' && idx < length - 1) {
      e.preventDefault();
      inputsRef.current[idx + 1].focus();
      inputsRef.current[idx + 1].setSelectionRange(1, 1);
    }
  };

  const handlePaste = e => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData('text');
    const digits = paste.replace(/\D/g, '').slice(0, length).split('');

    digits.forEach((d, i) => {
      if (inputsRef.current[i]) inputsRef.current[i].value = d;
    });

    const value = digits.join('');
    onChange?.(e, value);
    if (value.length === length) onComplete?.(value);
    inputsRef.current[Math.min(digits.length, length - 1)]?.focus();
  };

  return (
    <div className="field mt-5 d-flex align-items-center is-flex-direction-column">
      {helpLabel && (
        <label className={classNames('label', styles.label)} style={{ fontSize: '12px' }}>
          {helpLabel}
        </label>
      )}
      <div className="otp-inputs" style={{ display: 'flex', gap: '10px' }} onPaste={handlePaste}>
        {Array.from({ length }).map((_, i) => (
          <input
            key={i}
            name={inputName}
            type="text"
            autoComplete="off"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={1}
            className="input"
            style={{
              width: '3rem',
              height: '3rem',
              textAlign: 'center',
              fontSize: '1.25rem'
            }}
            ref={el => (inputsRef.current[i] = el)}
            onChange={e => handleChange(e, i)}
            onKeyDown={e => handleKeyDown(e, i)}
            aria-label={`Digit ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
